module.exports = __webpack_public_path__ + "static/media/EE.6668ee79.png";